@let vs = presenter.viewState();

<spa-button
  [ariaLabel]="vs.ariaLabel"
  [asset]="assetName()"
  [disabled]="vs.disabled"
  [display]="vs.display"
  [icon]="vs.showMatIcon ? vs.icon : ''"
  [iconPlacement]="vs.isTrailing ? 'icon-after' : 'icon-before'"
  [label]="vs.label"
  [shape]="shapeFor(vs.variant)"
  [type]="vs.type === 'submit' ? 'submit' : 'button'"
  (clickedButton)="presenter.onClick($event)"
/>
